import React from "react";

interface DuplicateIconProps extends React.SVGProps<SVGSVGElement> {
    size?: number;
    className?: string;
    color?: string;
}

const DuplicateIcon: React.FC<DuplicateIconProps> = ({ size = 16, className, color, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        className={className}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path d="M14.167 11.1673V13.6673C14.167 17.0007 12.8337 18.334 9.50033 18.334H6.33366C3.00033 18.334 1.66699 17.0007 1.66699 13.6673V10.5007C1.66699 7.16732 3.00033 5.83398 6.33366 5.83398H8.83366" stroke={color || "#292D32"} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14.1663 11.1673H11.4997C9.49967 11.1673 8.83301 10.5007 8.83301 8.50065V5.83398L14.1663 11.1673Z" stroke={color || "#292D32"} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.66699 1.66602H13.0003" stroke={color || "#292D32"} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.83301 4.16602C5.83301 2.78268 6.94967 1.66602 8.33301 1.66602H10.5163" stroke={color || "#292D32"} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M18.3329 6.66602V11.8243C18.3329 13.116 17.2829 14.166 15.9912 14.166" stroke={color || "#292D32"} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M18.333 6.66602H15.833C13.958 6.66602 13.333 6.04102 13.333 4.16602V1.66602L18.333 6.66602Z" stroke={color || "#292D32"} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />

    </svg>
);

export default DuplicateIcon;
